// Path should work with dot or array notation.
let PATH_REGEX = /[.["'\]]+/

/**
 * Returns a function which performs a getter action
 * @param {*} property  To be find
 * @param {*} defaultValue  To return as default
 * @return {Function} @getter
 */
function get (property, defaultValue) {
  // Split and clean empty paths.
  let path = property.split(PATH_REGEX).filter(Boolean)
  return function (element) {
    return typeof element === 'object'
      ? _readProperty(path, element, defaultValue)
      : element
  }
}

/**
 * Returns a function which performs a setter action
 * @param {*} property  To be set
 * @param {*} value     To be set
 * @return {Function} @setter
 */
function set (property, value) {
  // Split and clean empty paths.
  let path = property.split(PATH_REGEX).filter(Boolean)
  return function (element) {
    return typeof element === 'object'
      ? _setProperty(path, element, value)
      : element
  }
}

/**
 * Reads a property from an object
 * @param {*} path  Property path
 * @param {*} obj   To search in
 * @param {*} defaultValue  Default value
 * @return {*} Object property value or default value
 * @private
 */
function _readProperty (path, obj, defaultValue) {
  let pathLength = path.length

  return path.reduce(function (acc, key, index) {
    let value = acc && acc[key]
    let isLast = index + 1 === pathLength
    let isObject = value === Object(value)

    if (!isObject && !isLast) {
      return defaultValue
    }
    // should allow null and falsy values.
    return (value || (value !== undefined))
      ? value
      : defaultValue
  }, obj)
}

/**
 * Sets an object property value
 * @param {*} path  Property path
 * @param {*} obj   Which stores property
 * @param {*} value To be set
 * @return {*}
 * @private
 */
function _setProperty (path, obj, value) {
  return path.reduce(function (acc, key, index, array) {
    let isLast = (index === array.length - 1)
    acc[key] = isLast ? value : (acc[key] || {})
    return acc[key]
  }, obj)
}

export default { get, set }
